export default __webpack_public_path__ + "static/media/social-twt.05dc89c8.svg";